import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdCheck, MdDelete, MdSms, MdWhatsapp } from "react-icons/md";

export default function ClassroomRegistrationForm({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [name, setName] = useState("");
	const [applyStreams, setApplyStreams] = useState("no");
	const [supportedSubjects, setSupportedSubjects] = useState([]);


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllSubjects(),

		])
		setReady(true);
	}

	function addSubject() {
		setSupportedSubjects(_prev => {
			const _new = [..._prev];

			_new.push("")

			return _new;
		})
	}

	function removeSubject(index) {
		setSupportedSubjects(_prev => {

			const _new = [..._prev];

			_new.splice(index, 1);

			return _new;

		})
	}

	function handleSubjectChange(index, value) {
		setSupportedSubjects(_prev => {
			const _new = [..._prev];

			_new[index] = value;

			return _new;
		})
	}

	function cleanSubjects(_subjects) {
		const _cleaned = [... new Set(_subjects.filter((item, i) => {
			if(String(item).trim().length > 0) {
				return true;
			} else {
				return false;
			}
		}))]

		return _cleaned;
	}

	function resetClassroomForm() {
		setName("");
		setApplyStreams('no');
		setSupportedSubjects([]);
	}

	async function createClassroom() {
		const _subjects = cleanSubjects(supportedSubjects);
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'create-classroom',
				{
					name,
					applyStreams,
					supportedSubjects: JSON.stringify(_subjects),
					schoolUuid: appContext.currentSchoolUuid,
				}
			).then(response => {
				if(response.status === 1) {
					appContext.getAllClassrooms();
					appContext.tellMessage("Successful");
					resetClassroomForm()
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid name");
		}
	}

	async function edit() {
		const _subjects = cleanSubjects(supportedSubjects);
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'edit-classroom',
				{
					uuid: data.uuid,
					name,
					applyStreams,
					supportedSubjects: JSON.stringify(_subjects),
					schoolUuid: appContext.currentSchoolUuid,
				}
			).then(response => {
				if(response.status === 1) {
					
					if(callback) {
						callback();
					}

					appContext.tellMessage("Successful");
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid name");
		}
	}

	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	useEffect(() => {
		if(data) {
			setName(data.name);
			setSupportedSubjects(JSON.parse(data.supportedSubjects));
			setApplyStreams(data.applyStreams);
		}
	}, [ data ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Classroom's Name</label>
					<input
						className="form-control"
						value={name}
						onChange={e => setName(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Apply Streams to this classroom?</label>
					<select
						className="form-control"
						value={applyStreams}
						onChange={e => setApplyStreams(e.target.value)}
					>
						<option value="yes">Yes</option>
						<option value="no">No</option>
					</select>
				</div>

				{
					(applyStreams === 'no') ?
					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Allocated Subjects</label>
						{
							supportedSubjects.map((item, i) => {
								return (
									<div className="d-flex m-1" key={i}>
										<select
											className="form-control"
											
											style={{
												flexGrow: 1,
											}}
											onChange={(e) => handleSubjectChange(i, e.target.value)}
											value={item}
										>
											<option value="">Click to select subject</option>
											{
												appContext.allSubjects.map((item, i) => {
													return (
														<option key={i} value={item.uuid}>{item.name}</option>
													)
												})
											}
										</select>

										<MdDelete
											style={{
												flexShrink: 0,
												cursor: 'pointer'
											}}
											size={24}
											onClick={() => removeSubject(i)}
											className="text-danger"
										/>
									</div>
								)
							})
						}

						<div className="mt-2">
							<button
								className="btn btn-sm btn-outline-dark"
								onClick={addSubject}
							>
								Add Subject
							</button>
						</div>
					</div>
					:
					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Allocated Subjects</label>
						<h6
							style={{
								fontSize: "16px"
							}}
						>
							You have selected to use streams for this classroom, you'll be able to allocate subjects in specific streams under this classroom
						</h6>
					</div>
				}

				<div className="col-md-12 mt-2 mb-2 text-end">
					{
						(data) ?
						<button
							className="btn btn-secondary"
							onClick={() => {
								appContext.activateDialog({
									message: `Edit classroom information for ${name}?`,
									onConfirm: edit,
								})
							}}
						>
							<MdCheck/> Submit
						</button>
						:
						<button
							className="btn btn-secondary"
							onClick={() => {
								appContext.activateDialog({
									message: `Create new classroom, ${name}?`,
									onConfirm: createClassroom,
								})
							}}
						>
							<MdCheck/> Submit
						</button>
					}
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}